import script from "./MapRight-Layers.Item-Services.vue?vue&type=script&setup=true&lang=js"
export * from "./MapRight-Layers.Item-Services.vue?vue&type=script&setup=true&lang=js"

import "./MapRight-Layers.Item-Services.vue?vue&type=style&index=0&id=2a359040&lang=scss&scoped=true"

import exportComponent from "/vue-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a359040"]])

export default __exports__